<header>
    <mat-toolbar color="primary" class="mat-toolbar header">
        <mat-toolbar-row>
            <ng-content></ng-content>
            <div class="logo">
                <b>
                    <img  src="./assets/logo-new-black-text.png" alt="logo">
                   </b>
            </div>
            <div class="navbar-right">
                <div class="navbar-list">
                    <!-- <button mat-icon-button>
                            <mat-icon>account_circle</mat-icon>
                        </button>
                        <button mat-icon-button>
                            <mat-icon>notification_important</mat-icon>
                        </button> -->
                    <button mat-icon-button [matMenuTriggerFor]="menu">
                            <mat-icon>account_circle</mat-icon>
                            <mat-menu #menu="matMenu">
                                <button mat-menu-item [routerLink]="['/settings']" >
                                    <mat-icon >settings</mat-icon>
                                    <span>Setting</span>
                                </button>
                    <button mat-menu-item (click)="logout()">
                                    <mat-icon>logout</mat-icon>
                                    <span>Logout</span>
                                </button>
                    </mat-menu>
                    </button>
                </div>
            </div>
        </mat-toolbar-row>
    </mat-toolbar>
</header>